const types = [
    { value: "landlord_photo", name: '房东照片' },
    { value: "building_photo", name: '楼栋长照片' },
    { value: "grid_photo", name: '网格员照片' },
    { value: "charge_sign_photo", name: '导入场所负责人签收意见书' },
    { value: "building_ext_photo", name: '楼栋外景照片' },
    { value: "commitment_photo", name: '消防安全承认书' },
    { value: "train_photo", name: '消防安全基础培训照片' },
    { value: "inspect_photo", name: '检查照片' },
    { value: "review_photo", name: '复查照片' },
    { value: "fire_extinguisher_photo", name: '消防应急照明灯' },
    { value: "smoke_fire_photo", name: '感烟火灾探测器' },
    { value: "exit_photo", name: '安全出口疏散指示灯标识' },
    { value: "hose_reel_photo", name: '消防软管卷盘' },
    { value: "other_photo", name: '其他消防器材' },
]

const getName = (type) => {
    const item = types.find(item => {
        return type == item.value;
    })

    if (item) {
        return item.name;
    } else {
        return '';
    }

}

export {
    types,
    getName
}